<div class="boxed">
  <div class="site-card">
    <div [innerHTML]="imprintTxt.contact_content | i18next"></div>
  </div>
</div>
